// Logout.jsx
import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    signOut(auth).then(() => {
      navigate("/");
    });
  }, [navigate]);

  return <div style={{ padding: 20 }}>🚪 กำลังออกจากระบบ...</div>;
}
